//This object is used to set a blank application even it is the mock folder.

export default {
    general: {
      referredBy:'',
      hasAppliedBefore: null,
      whenAppliedBefore:'',
      whyAppliedBefore:'',
      hasHouseHoldAppliedBefore:null,
      whenHouseHoldAppliedBefore:'',
      whyHouseHoldAppliedBefore:'',
      hasCommunityAssistance:'',
      whenAppliedCommunityAssistance:'',
      whyAppliedCommunityAssistance:'',
      otherCountyEA:{
        otherCounty: [],
        otherCountyApprovedAmount: 0.00,
        nonEligibilityReason: ''
      },
      housingAssistance: null,
      fromAndAmount: '',
    },
    client: {
      phoneNumber:'',
      firstName: '',
      lastName: '',
      previousName: '',
      dateOfBirth: '',    
      ethinicity: {
        ethinics: [],
        otherEthinicity: null
      },
      maritalStatus: '',
      primaryLanguage: '',
      email: ''
    },
    housing: {
      noOfHouseHold : 0,
      houseHolds: [
        {
          collectionItemUniqueId: 1,
          name: '',
          dob: '',
          age: '',
          relationship: '',
          employed: ''
        }
      ],  
      homeless: null,  
      currentAddress: {
        streetAddress: '',
        city: '',
        state: '',
        zip: '',
        county: '',
        howLong: '',
        faceEviction: null,
        courtDateSet: null,
        courtDate: '',
        paymentPlan: null,
        utilityStatus: null,
        utilityShutOffNotice: null,
        shutOffDate: null
      }
      
    },
  
    shelter: {
      rentalCompany: {
        noOfRentalCompany : 0,      
        name: '',
        phoneNumber: '',
        address: '',
        fax: ''     
      },
      landlordPropMgr: {
        noOfLandlordPropMgr : 0,
        landlordPropMgrDetails:[
          {
            collectionItemUniqueId: 1,
            name: '',
            phoneNumber: '',
            address: ''
          }
        ]
      }
    },
  
    income: {
      ssi: 0.00,
      ssdi: 0.00,
      tanf: 0.00,
      snapEBT: 0.00,
      mfipDwip: 0.00,
      employment: 0.00,
      unEmployment: 0.00,
      childSupport: 0.00,
      other: 0.00,
      total: 0.00,
      otherKnownIncome: ''
    },
  
    expenses: {
      rentMortgage: 0.00,
      food: 0.00,
      carPayment: 0.00,
      carInsurance: 0.00,
      transport: 0.00,
      childCare: 0.00,
      cable: 0.00,
      internet: 0.00,
      diapers: 0.00,
      water: 0.00,
      electricity: 0.00,
      gas: 0.00,
      otherUtilities: 0.00,
      telephone: 0.00,
      laundry: 0.00,
      houseHoldItems: 0.00,
      total: 0.00,
      otherKnownExpenses: ''
    },
  
    services: {
      type: [],
      rentMortgage: 0.00,
      securityDeposit: 0.00,
      utilities: 0.00,
      carAssistance: 0.00,
      transportation: 0.00,
      medicalExpenses: 0.00,    
      food: 0.00,
      childCare: 0.00,
      other: 0.00,
      total: 0.00,
      events: '',    
      otherServices: ''
    },
  
    supportingDocuments: {
      mnIdentity: { includeFiles: null, files: [] },
      currentEmployed: { includeFiles: null, files: [] },
      currentUnEmployed: { includeFiles: null, files: [] },
      govtAssistance: { includeFiles: null, files: [] },
      approvalLetter: { includeFiles: null, files: [] },
      denialLetter: { includeFiles: null, files: [] },
      rentMortgage: { includeFiles: null, files: [] },
      securityDeposit: { includeFiles: null, files: [] },
      utilities: { includeFiles: null, files: [] },
      carAssistance: { includeFiles: null, files: [] },
      transportation: { includeFiles: null, files: [] },
      medicalExpenses: { includeFiles: null, files: [] },
      childCare: { includeFiles: null, files: [] },
      other: { includeFiles: null, files: [] }  
    },
  
    incomeProof_1: 'NA',
    servicesProof_1: 'NA',
  
    authorization: {
      noOfRef: 0,
      refSign: '',
      refDetails: [
        {
          collectionItemUniqueId: 1,
          refRecordNo: null,
          refName: '',
          refPhone: '',
          refRelationship: '',
          
        }
      ],
      noOfHelper: 0,
      helperDetails:[
        {
          helperRecordNo: null,
          helperName: '',
          heplerPhone: '',
          helperRelationship: ''
        }
      ]
    },
  
    
    applicationId: '',
  
    meta: {
      userId: '',
      hasReturnAustralia: null,
      hasSibling: null,
      isAltParent: null,
      reasonForSuspension: [],
      isAnaphylactic: null,
      isNonAnaphylactic: null,
      isOtherMedicalCondition: null,
      hasDoctorDetails: null,
      sectionExpandedId: 'general',
      visitedSections: [],
      hasAttemptToSubmit: null,
      additionalEmergencyContacts: ['yes'],
      hasAdditionalPostalAddress: false,
      toAddMoreParent: null
    },
    
    
    clientName_1: ''
  }
  